<template>
  <div id="left-3">
    <div class="title">
      <div class="header"></div>
      <div class="bg" :class="isActive==0?'active':''" @click="handleActive(0)">自行车场站</div>
      <div class="bg" :class="isActive==1?'active':''" @click="handleActive(1)">汽车场站</div>
    </div>
    <div class="marquee">
      <div class="table-header">
        <div class="header-item"></div>
        <div class="header-item">站点名称</div>
        <div class="header-item">当前订单数</div>
        <div class="header-item">当前营业额</div>
      </div>
      <vue-seamless-scroll :data="marqueeList" :class-option="optionHover" class="seamless-warp">
        <ul class="item">
          <li v-for="(item, index) in marqueeList" :key="index" class="item-height">
            <div class="li-item">
              <img v-if="item.dataType == 0" src="../../assets/pgzl-bicycle-bg.png" alt="" />
              <img v-else src="../../assets/pgzl-car-bg.png" alt="" />
            </div>
            <div class="li-item" v-text="item.chargingGroupName"></div>
            <div class="li-item" v-text="item.orderCount"></div>
            <div class="li-item" v-text="item.orderAmount"></div>
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
  </div>
</template>
<script>
// import bastTable from "../../components/base-table.vue";
import vueSeamlessScroll from "vue-seamless-scroll";
import axios from "axios";
export default {
  props: ["level", "regionId", "deviceType"],
  data() {
    return {
      timer: null,
      marqueeList: [],
      isActive:0,
    };
  },
  components: {
    // bastTable,
    vueSeamlessScroll,
  },
  computed: {
    optionHover() {
      return {
        step: 0.2, // 数值越大速度滚动越快
        limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  created() {
    // this.getData();
    this.timer = setInterval(() => {
      // setTimeout(this.getSouceData(), 0);
    }, 1000 * 5);
  },

  mounted() {
    // this.handleLoop();
    this.getRealTimeChargingGroupInfo(0)
    this.getDataCar();
  },
  methods: {
    handleActive(val){
      this.isActive = val;
      this.getRealTimeChargingGroupInfo(val)
    },
    handleLoop() {
      var start = 0;
      setInterval(() => {
        this.handleActive(start);
        start = start + 1;
        if (start > 1) {
          return (start = 0);
        }
      }, 5000);
      if(start==0){
        this.getRealTimeChargingGroupInfo(0)
      }else{
        this.getDataCar()
      }
    },
    getSouceData(){
      this.getRealTimeChargingGroupInfo(0)
      this.getDataCar()
    },
    // 自行车数据
    getRealTimeChargingGroupInfo(val) {
      this.$http({
        url: this.$http.adornUrl("/admin/api/realTime/getRealTimeChargingGroupInfo"),
        method: "get",
        params: this.$http.adornParams({
          // findType: this.deviceType?this.deviceType:val
          findType:val
        }),
      }).then(({ data }) => {
        if (data.code == 0) {
          this.marqueeList = data.data;
        }
      });
    },

    // 汽车场站数据
    getDataCar() {
      
      axios.get("https://saas.pgzl360.com/admin/api/realTime/getRealTimeChargingGroupInfo",{params:{
        // findType: 1,
      }}).then(res=>{
        // debugger
        console.log(res,'qiche汽车订单用户列表')
        if(res.data.code ==0){
          this.marqueeList = res.data.data;
        }
      })
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>
<style lang="scss" scoped>
#left-3 {
  width: 100%;
  height: 288px;
  // border: 1px solid red;
  .area-title {
    width: 284px;
    height: 32px;
    background: url("../../assets/pgzl-ranking-bg.png");
    background-size: cover;
    background-position: center center;
    color: #fff;
    font-size: 14px;
    line-height: 32px;
    span {
      margin-left: 40px;
    }
  }

  .marquee {
    width: 100%;
    margin-top: 16px;
    .table-header {
      display: flex;
      justify-content: space-around;
      width: 100%;
      height: 40px;
      line-height: 40px;
      background: linear-gradient(315deg, #0f2a77 0%, #0f2a77 100%);
      color: #00ecfc;
      font-size: 12px;
      .header-item {
        width: 20%;
        text-align: left;
      }
      .header-item:nth-child(1) {
        width: 5%;
      }
      .header-item:nth-child(2) {
        width: 50%;
      }
    }
    .seamless-warp {
      height: 200px;
      overflow: hidden;
      .item-height {
        height: 40px;
        width: 100%;
        line-height: 40px;
        display: flex;
        justify-content: space-around;
      }
      .item-height:nth-child(odd) {
        background: #020e3a;
      }
      .item-height:nth-child(even) {
        background: #071853;
      }
      .li-item {
        height: 40px;
        width: 20%;
        text-align: left;
        
      }
      .li-item:nth-child(1) {
        width: 5%;
        img {
          width: 20px;
          height: 20px;
        }
      }
      .li-item:nth-child(2) {
        width: 50%;
      }
    }
  }
  .title {
    // width: 100%;
    height: 32px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    display: flex;
    .header {
      width: 30px;
      height: 20px;
      background-image: url("../../assets/left-2-title.png");
      background-size: 30px 20px;
    }
    .bg {
      width: 130px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-image: url("../../assets/left-2-title-normal.png");
      background-size: 130px 30px;
    }
    .bg:nth-child(2) {
      margin-left: -25px;
    }
    .bg:nth-child(3) {
      margin-left: -18px;
    }
    .bg:hover {
      background-image: url("../../assets/left-2-big-title-active.png");
      background-size: 130px 30px;
      cursor: pointer;
    }
    .active {
      background-image: url("../../assets/left-2-big-title-active.png");
      background-size: 130px 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/left-3.vue